import styled from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';
import CustomTheme from '../assets/styles/theme';

export const ProfileSC = styled.div`
  .personal,
  .address,
  .birthday,
  .phone,
  .password {
    display: flex;
    justify-content: space-between;
  }

  [class$='-left'] {
    max-width: 170px;
    width: 100%;
    padding-top: 16px;
  }

  [class$='-right'] {
    width: 100%;
    margin-left: 45px;
  }

  div.address,
  div.phone,
  div.birthday {
    margin-top: 16px;
  }

  div.txt-inp {
    margin-bottom: 16px;
  }

  div.save-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .form-spacer {
    background-color: ${CustomTheme.form.separatorColor};
    margin-top: 35px;
    margin-bottom: 30px;
  }

  @media (max-width: ${Breakpoints.maxSmall}) {
    div.address,
    div.phone,
    div.birthday {
      margin-top: 0px;
    }

    [class$='-left'] {
      display: none;
    }

    [class$='-right'] {
      margin-left: 0px;
    }
  }
`;

export const FormSection = styled.div`
  width: 100%;
  max-width: 620px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: ${Breakpoints.maxSmall}) {
    max-width: none;
    padding-left: 16px;
    padding-right: 16px;

    div.sb-password-change,
    div.sb-phonenumber-change {
      display: none;
    }

    div.txt-inp {
      margin-bottom: 8px;
    }

    h5 {
      font-size: 16px;
      margin-bottom: 8px;
    }

    .save-wrapper {
      button {
        font-family: Roboto;
        font-size: 14px;
        font-weight: bold;
        line-height: 1.43;
        letter-spacing: 0.5px;
        height: 40px;
        padding: 10px 15px;
      }
    }
  }
`;
